import { Box, Typography } from "@mui/material";
import { motion } from "framer-motion";

const PageFallback = () => {
  return (
    <Box
      sx={{
        height: "100vh",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 2,
        backgroundColor: "background.default",
      }}
    >
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{
          opacity: [0.4, 1, 0.4],
          scale: [0.95, 1.05, 0.95],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut",
        }}
      >
        <Typography
          variant="h4"
          fontWeight={800}
          color="primary.main"
          sx={{ letterSpacing: "-0.05em" }}
        >
          &lt;/&gt;
        </Typography>
      </motion.div>
      
      <Box sx={{ width: 200, height: 2, bgcolor: "divider", overflow: "hidden", borderRadius: 1 }}>
        <motion.div
          initial={{ x: "-100%" }}
          animate={{ x: "100%" }}
          transition={{
            duration: 1.5,
            repeat: Infinity,
            ease: "linear",
          }}
          style={{
            height: "100%",
            width: "50%",
            background: "linear-gradient(90deg, transparent, #242424, transparent)",
          }}
        />
      </Box>

      <Typography
        variant="caption"
        sx={{
          mt: 1,
          color: "text.secondary",
          letterSpacing: 2,
          textTransform: "uppercase",
          opacity: 0.6,
        }}
      >
        Initializing
      </Typography>
    </Box>
  );
};

export default PageFallback;
